import React, { useState, useEffect } from "react";
import classes from "./ReportProblem.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import Ratings from "react-star-ratings";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";

export const ReportProblemModal = ({ show, setShow }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isProblem, setIsProblem] = useState();
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  const [detail, setDetail] = useState();
  const [adminMessage, setAdminMessage] = useState("");

  const problems = [
    "The student was late for training",
    "The student did not show up for training.",
    "Boorish behavior.",
    "Other (nothing from the above)",
  ];
  return (
    <>
      <style>{`
      .modal-body{
        padding:0px 32px;
      }
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.body} {
                  padding:0px 24px;
                }
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: adminMessage === "message-from-admin" ? "8px" : "24px",
        }}
        borderRadius={"20px"}
        footerStyles={
          isMobile
            ? {
              padding: "16px 24px",
              margin: "0px",
            }
            : {
              padding: "16px 32px",
              margin: "0px",
            }
        }
        width={"509px"}
        header={
          <div>
            <h4
              style={
                isMobile
                  ? {
                    ...Fonts.h3,
                    fontSize: "24px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }
                  : {
                    ...Fonts.h4,
                    fontSize: "26px",
                    lineHeight: "36px",
                    color: Colors.neutralShadesOfNero,
                  }
              }
            >
              Report a problem
            </h4>
          </div>
        }
        footer={
          adminMessage !== "message-from-admin" && (
            <div className={classes.footerBtns}>
              <Button
                label={"Cancel"}
                primary={false}
                size={"Large"}
                customStyle={{
                  width: "95px",
                  marginRight: "24px",
                  backgroundColor: Colors.white,
                  border: "none",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
              />
              <Button
                label={"Submit"}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: "120px",
                  height: "48px",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => setAdminMessage("message-from-admin")}
              />
            </div>
          )
        }
      >
        <div className={classes.modalContent}>
          {adminMessage === "message-from-admin" ? (
            <div className={[isMobile ? classes.mb24 : classes.mb32].join(" ")}>
              <p
                className={[classes.mb8].join(" ")}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              >
                Thanks for your feedback. We’re working hard to solve any
                difficulties that might happen. We’ll get back to you.
              </p>
              <p
                className={[classes.mb24].join(" ")}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              >
                You can also contact us directly if your problen wasn’t solved.
              </p>
              <Button
                primary={false}
                label={"Contact Lytesnap"}
                size={"Large"}
                customStyle={{
                  padding: '12px 32px',
                  width: 'max-content'
                }}
              />
            </div>
          ) : (
            <div className={[isMobile ? classes.mb24 : classes.mb32].join(" ")}>
              <div className={[classes.pb8].join(" ")}>
                {problems.map((item, i) => {
                  return (
                    <div className={[classes.mb16].join(" ")} key={i}>
                      <Checkbox
                        value={isProblem}
                        setValue={setIsProblem}
                        label={`${item}`}
                      />
                    </div>
                  );
                })}
              </div>
              <TextArea
                state={detail}
                setter={setDetail}
                placeholder="Details"
              />
            </div>
          )}
        </div>
      </ModalSkeleton>
    </>
  );
};
